import styled from "styled-components";
import { BASIC_ORANGE } from "../../../constants/colors";

type Props = {
  price: number;
  priceWithTax: number;
  isOriginalPrice?: boolean;
  isDiscountPrice?: boolean;
};

export const MenuPrice: React.FC<Props> = ({
  price,
  priceWithTax,
  isOriginalPrice,
  isDiscountPrice,
}) => {
  return (
    <MenuPriceText $strikeThrough={isOriginalPrice} $discount={isDiscountPrice}>
      税込<PriceWithTaxText>¥{priceWithTax.toLocaleString()}</PriceWithTaxText>{" "}
      <PriceText>(¥{price.toLocaleString()})</PriceText>
    </MenuPriceText>
  );
};

const MenuPriceText = styled.div<{
  $strikeThrough?: boolean;
  $discount?: boolean;
}>`
  font-size: 14px;
  font-weight: 600;
  ${({ $strikeThrough }) => $strikeThrough && "text-decoration: line-through;"}
  ${({ $discount }) => $discount && `color: ${BASIC_ORANGE};`}
`;

const PriceWithTaxText = styled.span`
  font-size: 13px;
  font-weight: 600;
`;

const PriceText = styled.span`
  font-size: 12px;
  font-weight: 500;
`;
